<template>
  <div class="container">
    <div class="line-chart">
      <line-chart></line-chart>
    </div>
    <div class="bar-chart">
      <bar-chart></bar-chart>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import lineChart from './lineChart'
import barChart from './barChart'

export default {
  components: {
    lineChart,
    barChart,
  },
}
</script>

<style scoped>
.container {
  margin-top: 1%;
  background-color: #ffffff;
  width: 99.5%;
}

.title {
  padding-top: 10px;
  margin: 1%;
}

.line-chart {
  width: 100%;
  height: 100%;
}

.bar-chart {
  height: 100%;
  width: 100%;
  background-color: #ffffff;
}
</style>
